import Form from './Form';
export default Form;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/form/index.js
// module id = 624
// module chunks = 0